<template>
  <div class="editAddress">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @failed="onFailed"
      @submit="onSubmit"
    >
      <van-field
        v-model="form.ReceivingName"
        :label="$t.address.receivingName"
        :placeholder="$t.address.input"
        required
        :rules="[
          {
            required: true,
            message: $t.address.input + ' ' + $t.address.receivingName,
          },
        ]"
      />

      <van-field
        v-model="form.PhoneNumber"
        :label="$t.address.phoneNumber"
        :placeholder="$t.address.input"
        required
        :rules="[
          {
            required: true,
            message: $t.address.input + ' ' + $t.address.phoneNumber,
          },
        ]"
      />

      <van-field
        v-model="form.Email"
        :label="$t.address.email"
        :placeholder="$t.address.input"
        required
        :rules="[
          {
            required: true,
            message: $t.address.input + ' ' + $t.address.email,
          },
        ]"
      />

      <van-field
        v-model="form.PostalCode"
        :label="$t.address.postcode"
        :placeholder="$t.address.input"
      />

      <van-field
        readonly
        clickable
        :value="country.text"
        :label="$t.address.country"
        :placeholder="$t.address.select"
        @click="onShowCountry"
        required
        :rules="[
          {
            required: true,
            message: $t.address.select + ' ' + $t.address.country,
          },
        ]"
      />
      <van-field
        readonly
        clickable
        :value="city.text"
        :label="$t.address.city"
        :placeholder="$t.address.select"
        @click="onShowCity"
        required
        :rules="[
          {
            required: true,
            message: $t.address.select + ' ' + $t.address.city,
          },
        ]"
      />

      <van-field
        v-model="form.ReceivingAddress"
        :label="$t.address.receivingAddress"
        :placeholder="$t.address.input"
        type="textarea"
        required
        :rules="[
          {
            required: true,
            message: $t.address.input + ' ' + $t.address.receivingAddress,
          },
        ]"
      />

      <van-field :label="$t.address.isDefault">
        <template #input>
          <van-switch v-model="form.IsDefult" size="20" />
        </template>
      </van-field>

      <div style="margin: 16px">
        <van-button
          block
          type="info"
          color="#2750aa"
          style="border-radius: 10px"
          native-type="submit"
          >{{ $t.address.submit }}</van-button
        >
      </div>

      <div style="margin: 16px" v-if="isEdit && !isSelection">
        <van-button
          block
          type="danger"
          style="border-radius: 10px"
          @click="onDelete"
          native-type="button"
          >{{ $t.address.delete }}</van-button
        >
      </div>
    </van-form>

    <option-list
      event="showAddressCountrys"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showAddressCities"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Switch } from "vant";
import OptionList from "@components/optionList/OptionList.vue";

Vue.use(Form).use(Field).use(Button).use(Switch);
export default {
  name: "editAddress",
  props: {
    addressData: {
      type: Object,
      default: null,
    },
    isSelection: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    OptionList,
  },
  data() {
    return {
      language: localStorage.getItem("requestLanguage") || "auto",
      isEdit: false,
      countryList: [],
      country: {
        text: "",
        value: "",
      },
      cityList: [],
      city: { text: "", value: "" },
      form: {
        CRId: null,
        ReceivingName: "",
        PhoneNumber: "",
        Email: "",
        PostalCode: "",
        CountryId: null,
        CityId: null,
        ReceivingAddress: "",
        IsDefult: false,
      },
    };
  },
  created() {
    if (this.isSelection) {
      this.getOptions().then((success) => {
        if (success) {
          if (this.addressData) {
            this.form = this.addressData;
            this.applyData(this.addressData);
          }
        }
      });
    } else {
      const query = this.$route.query;
      this.getOptions().then((success) => {
        if (success) {
          if (query.Address) {
            this.isEdit = true;
            this.form = query.Address;
            this.applyData(query.Address);
          }
        }
      });
    }
  },
  methods: {
    applyData(data) {
      this.country.text = data.CountryName;
      this.country.value = data.CountryId;
      this.city.text = data.CityName;
      this.city.value = data.CityId;
      this.getCityList(data.CountryId, false);
      if (data.IsDefult == 1) {
        this.form.IsDefult = true;
      } else {
        this.form.IsDefult = false;
      }
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.getCountryList()]).then((success) => {
          if (success) {
            resolve(true);
          }
          this.$commonMethod.hideLoading();
        });
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    onShowCountry() {
      this.$bus.$emit("showAddressCountrys", true);
    },
    onSelectCountry(item) {
      this.country.text = item.text;
      this.country.value = item.value;
      this.getCityList(item.value, true);
    },
    onShowCity() {
      this.$bus.$emit("showAddressCities", true);
    },
    onSelectCity(item) {
      this.city.text = item.text;
      this.city.value = item.value;
    },
    getCountryList() {
      var param = {
        BusinessType: 1,
      };
      return new Promise((resolve) => {
        this.$api.user
          .getTakeDeliveryCountryCityList(param)
          .then((res) => {
            this.formatCountry(res.data);
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    formatCountry(data) {
      var result = [];
      data.forEach((item) => {
        var cityList = [];
        if (item.CityList) {
          for (var city of item.CityList) {
            cityList.push({
              text: this.language == "zh" ? city.City_cn : city.City_en,
              value: city.CityId,
            });
          }
        }
        let data = {
          text: this.language == "zh" ? item.CountryName : item.CountryName_en,
          value: item.CountryId,
          cityList: cityList,
        };
        result.push(data);
      });
      this.countryList = result;
    },
    getCityList(countryId, isReset) {
      for (let country of this.countryList) {
        if (country.value == countryId) {
          this.cityList = country.cityList;
          if (isReset) {
            this.city.text = "";
            this.city.value = null;
          }
        }
      }
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CountryId = this.country.value;
      param.CountryName = this.country.text;
      param.CityId = this.city.value;
      param.CityName = this.city.text;
      if (this.form.IsDefult) {
        param.IsDefult = 1;
      } else {
        param.IsDefult = 0;
      }
      var request = null;
      if (this.isEdit || this.addressData) {
        request = this.$api.address.editCustomerReceiving(param);
      } else {
        request = this.$api.address.addCustomerReceiving(param);
      }
      request
        .then((res) => {
          if (this.isSelection) {
            this.$emit("addressDidChanged");
          } else {
            this.$commonMethod.dialogAlert(
              res.message ? res.message : res.Message,
              () => {
                this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
              }
            );
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onFailed(errorInfo) {
      if (errorInfo && errorInfo.errors.length > 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: errorInfo.errors[0].message,
        });
      }
    },
    onDelete() {
      this.$commonMethod.showLoading();
      let param = {
        CRId: this.form.CRId,
      };
      this.$api.address
        .deleteCustomerReceiving(param)
        .then((res) => {
          if (this.isSelection) {
            this.$emit("addressDidChanged");
          } else {
            this.$commonMethod.dialogAlert(
              res.message ? res.message : res.Message,
              () => {
                this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
              }
            );
          }
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.editAddress {
  ::v-deep .van-form {
    .van-cell__title {
      flex: unset !important;
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .van-switch--on {
    background-color: #2750aa !important;
  }
}
</style>
